// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cJAK5gpkI4B4_q6UCBI6 {
  width: 45px;
  height: 45px;
}

.Wwg1rMk4nzj1_7L4c7tF {
  width: 150px;
  height: 150px;
}

.CimUjVoUAmq6n2FMVqYW {
  width: 45px;
  height: 45px;
}

.Rzf2pBRUlK55EQaHEqsn {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
}

.XcV0yBode16XJU2FAcKe {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  margin-left: 5px;
}

.Ep7LXwuZKOhTOJlBsRAp .nW3MF62NXF5rcq56N6xA {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
}

.SQGDiyK65KUD_IHtFh_g {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
  font-size: 20px;
  white-space: pre-line;
  margin-left: 40px;
  margin-right: 40px;
}

.jVqs93yHtFmDU2_d1cqj {
  font-size: 14px
}

.lQJ9wSnf9Cfoy7PUXiAs {
  font-size: 30px;
}

.Ep7LXwuZKOhTOJlBsRAp {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.uPxsmrQPp7hUxAvfQkQ3 {
  width: 100%;
  height: 50px;
}

.gxVbtWaIpAnhHG8F5ki7 {
  display: contents;
  font-size: 16px;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Modal/Modal.module.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mDAAiB;AACnB;;AAEA;EACE,mDAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mDAAkB;AACpB;;AAEA;EACE,mDAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-text, color-text-subtle, color-purple, color-error from colors;\n\n.icon {\n  width: 45px;\n  height: 45px;\n}\n\n.successConfetti {\n  width: 150px;\n  height: 150px;\n}\n\n.spinner {\n  width: 45px;\n  height: 45px;\n}\n\n.colorText {\n  color: color-text;\n}\n\n.blue {\n  color: color-purple;\n  margin-left: 5px;\n}\n\n.bodyModal .error {\n  color: color-error;\n}\n\n.text {\n  color: color-text;\n  font-size: 20px;\n  white-space: pre-line;\n  margin-left: 40px;\n  margin-right: 40px;\n}\n\n.font14 {\n  font-size: 14px\n}\n\n.font30 {\n  font-size: 30px;\n}\n\n.bodyModal {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n}\n\n.button {\n  width: 100%;\n  height: 50px;\n}\n\n.ghostButton {\n  display: contents;\n  font-size: 16px;\n  font-weight: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"icon": `cJAK5gpkI4B4_q6UCBI6`,
	"successConfetti": `Wwg1rMk4nzj1_7L4c7tF`,
	"spinner": `CimUjVoUAmq6n2FMVqYW`,
	"colorText": `Rzf2pBRUlK55EQaHEqsn`,
	"blue": `XcV0yBode16XJU2FAcKe`,
	"bodyModal": `Ep7LXwuZKOhTOJlBsRAp`,
	"error": `nW3MF62NXF5rcq56N6xA`,
	"text": `SQGDiyK65KUD_IHtFh_g`,
	"font14": `jVqs93yHtFmDU2_d1cqj`,
	"font30": `lQJ9wSnf9Cfoy7PUXiAs`,
	"button": `uPxsmrQPp7hUxAvfQkQ3`,
	"ghostButton": `gxVbtWaIpAnhHG8F5ki7`
};
export default ___CSS_LOADER_EXPORT___;
